import { atom } from "recoil";

export const progressOpenMapAtom = atom<Record<string, boolean>>({
  key: "progressOpenMapAtom",
  default: {},
});
